import { styled } from '@eneco/sparky/stitches';

export const SplitViewItemWrapper = styled('div', {
  overflow: 'hidden',
  picture: {
    display: 'flex',
  },
});
